import React from "react";
import CustomSelect from "../../../../common/CustomSelect";
import CustomButton from "../../../../common/CustomButton";
import AsteriskStyle from "../../../../Form/Tooltip/AsteriskStyle";
import LeadDropdown from "../../../../Form/LeadTable/LeadDropdown";

const BasicInfoStep = ({
  selectedPropertyType,
  towerOptions,
  unitNumberOptions,
  leadOptions,
  setSearchLead,
  searchLead,
  formData,
  onInputChange,
  selectedTower,
  setSelectedTower,
  onSubmit,
  loading,
}) => {
  return (
    <div className="flex flex-col gap-5 p-4">
      {selectedPropertyType === "Apartment" && (
        <div className="grid grid-cols-12 items-center">
          <label className="col-span-4 text-sm font-medium text-gray-700">
            Tower <AsteriskStyle />
          </label>
          <div className="col-span-8">
            <CustomSelect
              options={towerOptions.map((list) => ({
                value: list?.id,
                label: list?.name,
              }))}
              value={selectedTower}
              onChange={(selected) => setSelectedTower(selected)}
              placeholder="Select Tower"
            />
          </div>
        </div>
      )}

      <div className="grid grid-cols-12 items-center">
        <label className="col-span-4 text-sm font-medium text-gray-700">
          Unit Number <AsteriskStyle />
        </label>
        <div className="col-span-8">
        <CustomSelect
  options={unitNumberOptions.map((list) => ({
    value: list?.id,
    label: list?.name,
  }))}
  value={formData.selectedUnit}
  onChange={(selected) => onInputChange("selectedUnit", selected)}
  placeholder="Select Unit Number"
/>

        </div>
      </div>

      <div className="grid grid-cols-12 items-center gap-2">
        <label className="col-span-4 text-sm font-medium text-gray-700">
          Lead <AsteriskStyle />
        </label>
        <div className="col-span-8">
          <LeadDropdown
            leadOptions={leadOptions}
            searchLead={searchLead}
            setSearchLead={setSearchLead}
            onSelect={(selected) => onInputChange("selectedLead", selected)}
          />
        </div>
      </div>

      <div className="grid grid-cols-12 items-center">
        <label className="col-span-4 text-sm font-medium text-gray-700">
          Loan Percentage <AsteriskStyle />
        </label>
        <div className="col-span-8 relative w-full">
          <input
            type="number"
            
            value={formData.selectedPercentage }
            onChange={(e) => {
              const value = e.target.value;
              const regex = /^\d{0,2}(\.\d{0,2})?$/;
              if (
                value === "" ||
                (regex.test(value) &&
                  Number(value) >= 0 &&
                  Number(value) <= 100)
              ) {
                onInputChange("selectedPercentage", value);
              }
            }}
            onKeyDown={(e) => {
              if (["e", "E", "+", "-"].includes(e.key)) {
                e.preventDefault();
              }
            }}
            className="w-full px-3 py-2 pr-16 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500"
            placeholder="Loan Percentage"
          />
          <span className="absolute right-1 top-1/2 bg-slate-100 rounded-md px-4 py-2 -translate-y-1/2 text-gray-500 text-sm pointer-events-none">
            In %
          </span>
        </div>
      </div>

      <div className="flex justify-center ">
        <CustomButton
          label={"Next"}
          onClick={onSubmit}
          className={"w-[320px]"}
        />
      </div>
    </div>
  );
};

export default BasicInfoStep;
